export default __webpack_public_path__ + "static/media/formLevelErrorsMenuIcon.1fa4c8ab.svg";